import { render, staticRenderFns } from "./UserIdentityVerification.vue?vue&type=template&id=b56c7a42&"
import script from "./UserIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./UserIdentityVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports